// Import ES6 Promise
import 'es6-promise/auto'

// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'

import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'

import moment from 'vue-moment'

// Import Helpers for filters
import { domain, count, prettyDate, pluralize } from './filters'

// Import Views - Top level
import AppView from './components/App.vue'

import msal from 'vue-msal'

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)

Vue.use(VueRouter)
Vue.use(moment)

// Routing logic
var router = new VueRouter({
  routes: routes,
  // mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

sync(store, router)

var redirectUri, postLogoutRedirectUri
if (location.href.toLowerCase().indexOf('://localhost') > 0) {
  redirectUri = 'http://localhost:8080'
  postLogoutRedirectUri = 'http://localhost:8080/#/AuthPage'
} else {
  redirectUri = 'https://dashboard.intelisoft.ca'
  postLogoutRedirectUri = 'https://dashboard.intelisoft.ca/#/AuthPage'
}

Vue.use(msal, {
  auth: {
    clientId: '335df107-cbf6-451e-8a11-89617605bb2d',
    tenantId: '8e18cd54-284d-4c48-853f-b8eb22b82da7',
    redirectUri: redirectUri,
    postLogoutRedirectUri: postLogoutRedirectUri,
    autoRefreshToken: true
  },
  cache: {
    cacheLocation: 'sessionStorage'
  }
})

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView)
})



// WEBPACK FOOTER //
// ./src/main.js